import { Injectable } from '@angular/core';

/** 
* Service Utilizzato come cache per mantenere lo stato delle DataTable
* (v. Directive TableStateService)
*/
@Injectable()
export class TableFilterService {

  private filters: Map<string, any> = new Map<string, any>();

  constructor() { }

  public hasFilters(key: string): boolean {
    return this.filters.has(key);
  }

  public getFilters(key: string): any {
    if(!this.hasFilters(key))  {
      return {
        filters: {},
        first: 0
      };
    }

    return this.filters.get(key);
  }

  public setFilters(key: string, filter: any) {
    return this.filters.set(key, filter);
  }

  public resetFilter(key: string): void {
    this.filters.delete(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/table-filter/table-filter.service.ts